import { connect } from 'react-redux'
import * as selector from '../../../customer/state/detail/selector'
import CreateIprAppointment from '../task-detail/CreateIprAppointment'

const mapStateToProps = (state) => {
    return {
        customer: selector.selectCustomer(state),
    }
}

export default connect(mapStateToProps)(CreateIprAppointment)



// WEBPACK FOOTER //
// ./src/modules/process/component/task-widget/CreateIprAppointmentContainer.js